import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/transactions-history-page.json'

const t = getTranslationFromJson([content])

export const useCardName = (cardType: string) => {
  const cardsRec: Record<string, string> = {
    visa: t('visa_label'), // Visa
    master: t('master_label'),
    mastercard: t('master_label'), // Mastercard
    american_express: t('amex_label'),
    amex: t('amex_label'), // American Express
    diners_club: t('diners_club_label'), // Diners Club
    dinersclub: t('diners_club_label'),
    discover: t('discover_label'), // Discover
    unionpay: t('unionpay_label'), // UnionPay
    jcb: t('jcb_label'), // JCB
    maestro: t('maestro_label'), // Maestro
    verve: t('verve_label'), // Verve
    confiable: t('confiable_label'), // Confiable
    alelo: t('alelo_label'), // Alelo
  }

  if (cardType && cardType in cardsRec) {
    return cardsRec[cardType]
  }

  return t('card_label')
}
